import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import ContactUsForm from '../../components/inner-components/ContactUsForm';
import TeamOne from '../../components/section-components/TeamOne';
import Quote from '../../components/section-components/Quote';
import FooterOne from '../../common/footer/FooterOne';

const ContactUs = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Contact Us"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Contact Us"
        />
        
        <ContactUsForm />
        
        <TeamOne />
        
        <Quote />
        
        <FooterOne />
        </>
    )
}
    
export default ContactUs;